import "frontend-layout";
import "./helpers";
import "./event";
import "./object";
import "./payment";
import "./locations";

// 
(function($) {
    "use strict";
    var timeouts = [];
    $(document).on("click", ".event-actions-dropdown", function(e) {
        e.preventDefault();

        e.stopImmediatePropagation();
        for (var i = 0; i < timeouts.length; i++) {
            clearTimeout(timeouts[i]);
        }
        let dropdowEvent = $(this).attr("data-toggle");

        $(".event-actions-dropdown").each(function() {
            let elementID = $(this).attr("data-toggle");
            if (dropdowEvent !== elementID) {
                const dropdownElement = new Foundation.Dropdown($("#" + elementID));
                dropdownElement.close();
            }
        });
        const dropdownE = new Foundation.Dropdown($("#" + dropdowEvent));
        dropdownE.toggle($("#" + dropdowEvent));

        $("#" + dropdowEvent).on("mouseleave", function() {
            timeouts.push(
                setTimeout(() => {
                    dropdownE.close();
                }, 2000)
            );
        });
    });
    // 
    $(document).on("click", ".event-date-actions-button", function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        for (var i = 0; i < timeouts.length; i++) {
            clearTimeout(timeouts[i]);
        }
        let dropdowEvent = $(this).attr("data-toggle");
        $(".event-date-actions-button").each(function() {
            let elementID = $(this).attr("data-toggle");
            if (dropdowEvent !== elementID) {
                const dropdownElement = new Foundation.Dropdown($("#" + elementID));
                dropdownElement.close();
            }
        });
        const dropdown = new Foundation.Dropdown($("#" + dropdowEvent));
        dropdown.toggle($("#" + dropdowEvent));

        $("#" + dropdowEvent).on("mouseleave", function() {
            timeouts.push(
                setTimeout(() => {
                    dropdown.close();
                }, 2000)
            );
        });
    });

    $(".no-copy").bind("cut copy paste", function(e) {
        e.preventDefault();
    });

    $(document).on("click", ".modal-contacts-open", function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        let modal = $(this).attr("data-open");

        new Foundation.Reveal($("#" + modal), { deepLink: true }).open();
    });

    $(document).on("click", ".modal-info-open", function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        let modal = $(this).attr("data-open");

        new Foundation.Reveal($("#" + modal), { deepLink: true }).open();
    });
})(jQuery);